import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { callAPI, clearRequest, handleApiError, IRoleMain, LoacalVariables, Method, setLocalValues } from "../../commonFunctions/CommonFunctions";
import { AllPermissions } from "../../commonFunctions/PermissionManger";
import backImg from "../../images/login-bg.svg";
import logo from "../../images/logo.svg";

interface LoginFormProps {
    onLogin: (token: string) => void;
}

export const LoginForm: React.FC<LoginFormProps> = React.memo(({ onLogin }) => {
    const { control, register, handleSubmit, formState: { errors } } = useForm();
    const { showMessage } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const handleData = async (data: any) => {
        try {
            const request = {
                email: data.email,
                password: data.password,
                // roleType: 0
            }
            const newRequest = clearRequest(request);
            setLoading(true);

            // const response: any = await callAPI("auth/login", Method.POST, newRequest); old with role type
            const response: any = await callAPI("auth/loginNew", Method.POST, newRequest); // new without role type

            console.log("Login Response:", response);
            if (response?.errors) {
                const mess = handleApiError(response)
                showMessage(mess, 'error');
            }
            else if (response && response?.token) {
                onLogin(response?.token);
                setLocalValues(LoacalVariables.UserId, response?.userId);

                const name = `${response?.firstName} ${response?.lastName ? response?.lastName : ''} `
                setLocalValues(LoacalVariables.Name, name);
                setLocalValues(IRoleMain.Permissions, response?.permissions)
                setLocalValues(LoacalVariables.Branch,response?.branchId)
                setLocalValues(LoacalVariables.RoleType,response?.roleType)
                AllPermissions.getInstance();
                showMessage("Logged in successfully!", "success");
            } else {
                throw new Error("Login failed. Please try again.");
            }
        } catch (e: any) {
            showMessage(e.message || "An unexpected error occurred.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid sx={{ padding: 5 }} item container>
            <Grid sm={6} style={{ marginTop: -23 }}>
                <img src={logo} style={{ marginTop: -2 }} ></img>
            </Grid>
            {/* <Grid sm={6} style={{ marginTop: -23 }} sx={{ mt: -2, display: 'flex', justifyContent: 'flex-end' }}>
                <Typography variant="body2" >Don't have an MHB account ? <Link style={{ textDecoration: 'none' }} to={'/registration'}  >Sign Up</Link></Typography>
            </Grid> */}
            <Grid
                container
                sx={{
                    backgroundImage: `url(${backImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '85vh',
                    borderRadius: 5,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                }}
            >
                <form onSubmit={handleSubmit(handleData)}>
                    <Box
                        sx={{
                            backgroundColor: "white",
                            padding: "30px",
                            borderRadius: "12px",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                            maxWidth: "400px",
                            width: "100%",
                            textAlign: 'center'
                        }}
                    >
                        <Typography variant="h5" fontWeight="bold">
                            Welcome <span style={{ color: "red" }}>Back!</span>
                        </Typography>
                        <Typography variant="body2" color="gray" sx={{ mb: 2 }}>
                            Log in to your Account
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <WSTextField
                                    label="Email"
                                    {...register("email", { required: "Email number is required" })}
                                    id="email"
                                    name="email"
                                    control={control}
                                    //  maxLength={10}

                                    sx={{

                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <WSTextField
                                    label="Password"
                                    {...register("password", { required: "Password is required" })}
                                    id="password"
                                    name="password"
                                    control={control}
                                    type={TextType.Password}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                        },
                                    }}
                                />

                            </Grid>
                            {/* <Grid item xs={12}>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <FormControlLabel
                                        control={<Checkbox sx={{ color: "green" }} />}
                                        label="Remember me"
                                    />
                                    <Typography
                                        variant="body2"
                                        sx={{ color: "blue", cursor: "pointer", textDecoration: "none" }}
                                    >
                                        Forgot Password?
                                    </Typography>
                                </Box>
                            </Grid> */}
                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#232F6B",
                                        color: "white",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        mt: 0,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? "Logging in..." : "Login"}
                                </Button>
                                {/* <WSButton
                id="login"
                label="Log In"
                size="large"
                variant="contained"
                type="submit"
                loading={loading}
                sx={{
                    backgroundColor: "#232F6B",
                    color: "white",
                    padding: "10px",
                    borderRadius: "8px",
                    mt: 2,
                  }}
              /> */}
                            </Grid>
                        </Grid>






                    </Box>
                </form>
            </Grid>
        </Grid>
    );
});
